export const ActionTypes = {
  SUBMIT_PURCHASE_LEAD_PACK_UPSELL_START: 'SUBMIT_PURCHASE_LEAD_PACK_UPSELL_START',
  SUBMIT_PURCHASE_LEAD_PACK_UPSELL_FINISH: 'SUBMIT_PURCHASE_LEAD_PACK_UPSELL_FINISH',
  SUBMIT_PURCHASE_LEAD_PACK_UPSELL_SUCCESS: 'SUBMIT_PURCHASE_LEAD_PACK_UPSELL_SUCCESS',
  SUBMIT_PURCHASE_LEAD_PACK_UPSELL_ERROR: 'SUBMIT_PURCHASE_LEAD_PACK_UPSELL_ERROR',
  FETCH_SESSION: 'LeadPackUpsell/FETCH_SESSION'
};
